import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { ChartLine, Megaphone, Users, Images, Gear, SignOut, ChartBar, Globe } from "@phosphor-icons/react";

export default function AdminLayout() {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("seva_admin_token");
    nav("/admin/login");
  };
  const name = localStorage.getItem("seva_admin_name") || "Admin";

  const items = [
    { to: "/admin", label: "Dashboard", Icon: ChartLine, end: true },
    { to: "/admin/campaigns", label: "Campaigns", Icon: Megaphone },
    { to: "/admin/donors", label: "Donors", Icon: Users },
    { to: "/admin/reports", label: "Reports", Icon: ChartBar },
    { to: "/admin/slider", label: "Slider", Icon: Images },
    { to: "/admin/website", label: "Website", Icon: Globe },
    { to: "/admin/settings", label: "Settings", Icon: Gear },
  ];

  return (
    <div className="min-h-screen bg-[#FBF9F6]">
      <div className="flex">
        <aside className="hidden md:flex md:w-64 lg:w-72 shrink-0 flex-col bg-[#1F2A1C] text-white min-h-screen sticky top-0">
          <div className="px-6 py-6 border-b border-white/10">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-[#4FAC39] grid place-items-center font-display font-bold">S</div>
              <div>
                <div className="font-display font-bold">SEVA Admin</div>
                <div className="text-xs text-white/60">Control Room</div>
              </div>
            </div>
          </div>
          <nav className="flex-1 p-3 space-y-1">
            {items.map(({ to, label, Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                data-testid={`nav-${label.toLowerCase()}`}
                className={({ isActive }) =>
                  "flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-sm font-medium " +
                  (isActive
                    ? "bg-[#4FAC39] text-white shadow-[0_4px_14px_rgba(224,106,59,0.45)]"
                    : "text-white/80 hover:bg-white/5 hover:text-white")
                }
              >
                <Icon size={18} weight="fill" />
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-white/10">
            <div className="text-sm text-white/90 mb-2">{name}</div>
            <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 text-white/80 text-sm" data-testid="admin-logout">
              <SignOut size={16} /> Sign out
            </button>
          </div>
        </aside>

        {/* Mobile top bar */}
        <div className="flex-1 flex flex-col min-w-0">
          <div className="md:hidden bg-[#1F2A1C] text-white sticky top-0 z-30">
            <div className="flex items-center justify-between px-4 py-3">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#4FAC39] grid place-items-center font-display font-bold text-sm">S</div>
                <span className="font-display font-bold">SEVA Admin</span>
              </div>
              <button onClick={logout} className="text-white/80 text-sm" data-testid="admin-logout-mobile">Sign out</button>
            </div>
            <div className="flex overflow-x-auto px-2 pb-2 gap-1 border-t border-white/10">
              {items.map(({ to, label, end }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    "shrink-0 px-4 py-2 rounded-lg text-sm " + (isActive ? "bg-[#4FAC39] text-white" : "text-white/70")
                  }
                >
                  {label}
                </NavLink>
              ))}
            </div>
          </div>

          <main className="p-5 md:p-8 lg:p-10 max-w-7xl w-full mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
